import { render, staticRenderFns } from "./AnimatedLoading.vue?vue&type=template&id=21adae40&"
import script from "./AnimatedLoading.vue?vue&type=script&lang=js&"
export * from "./AnimatedLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports